var image_upload_default = {
  "container": "_3XWqh",
  "disabled": "ItWl5",
  "imageInput": "HrlS4",
  "overlay": "SiKWL",
  "text": "wQrcV",
  "shown": "OVnpr",
  "hide": "_4imY5",
  "spinner": "h7AvD",
  "spin": "ptece"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
